import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { getOcStatusBadgeVariant, getOcStatusLabel } from '../../utils/ocRequest';

const OcRequestStatusBadge = ({ status }) => (
  <Badge bg={getOcStatusBadgeVariant(status)}>{getOcStatusLabel(status)}</Badge>
);

export default OcRequestStatusBadge;
